import * as constAction from 'root/actionConstants';
import { Map, List, fromJS } from 'immutable';

var defaultState = Map({
  lista: List(),
  cuantosHay: 0,
  scrollControl: Map({
    hasMore: true,
    page: 0,
    fecha: null,
  }),
});

export default function reducer(state = defaultState, action) {
  switch (action.type) {
    case constAction.REPORTES_CLEAR: {
      if (action.payload === 'all') return defaultState;
      else if (defaultState.has(action.payload)) return state.set(action.payload, defaultState.get(action.payload));
      else {
        console.error('No existe la propiedad ' + action.payload);
        return state;
      }
    }
    case constAction.REPORTES_SET_STATE: {
      let newState = state;
      for (var key in action.payload) newState = newState.set(key, fromJS(action.payload[key]));
      return newState;
    }
    default:
      return state;
  }
}



// WEBPACK FOOTER //
// src/modules/reportes/reducer.js